import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractProblemForUserApiService } from '../abstract/abstract-problem-for-user-api-service';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { ProblemForUserModel } from 'src/app/store/problem-user/model';

const problemUrl = `/api/problems`;
const problemSubscriptionsUrl = `/api/ProblemSubscriptions`;
const problemLocksUrl = `/api/ProblemLocks`;

@Injectable()
export class ProblemForUserApiService extends AbstractProblemForUserApiService {
  private http = inject(HttpClient);

  getActiveProblems(userId: number): Observable<InteractorResponse<ProblemForUserModel[]>> {
    return this.http.get<InteractorResponse<ProblemForUserModel[]>>(`${problemUrl}/active?userId=${userId}`);
  }

  subscriptionProblem(problemId: number, userId: number): Observable<InteractorResponse<ProblemForUserModel>> {
    return this.http.post<InteractorResponse<ProblemForUserModel>>(`${problemSubscriptionsUrl}`, {
      ProblemId: problemId,
      UserId: userId,
    });
  }

  unSubscriptionProblem(subscriptionId: number): Observable<InteractorResponse<ProblemForUserModel>> {
    return this.http.delete<InteractorResponse<ProblemForUserModel>>(`${problemSubscriptionsUrl}/${subscriptionId}`);
  }

  lockProblem(problemId: number, userId: number): Observable<InteractorResponse<ProblemForUserModel>> {
    return this.http.post<InteractorResponse<ProblemForUserModel>>(`${problemLocksUrl}`, {
      ProblemId: problemId,
      UserId: userId,
    });
  }
}
